import React from "react";
import ReactMarkdown from "react-markdown";
import SubTitleSection from "src/components/SubTitleSection/SubTitleSection";
import styled from "styled-components";

const TitanRules = ({ title, content, highlightColor }) => (
  <RulesDiv className="mt-5 py-5 px-3">
    <container-div>
      <SubTitleSection
        as="h2"
        subTitle={title}
        className="pt-0"
        borderColor={highlightColor}
      />
      <ReactMarkdown>{content}</ReactMarkdown>
    </container-div>
  </RulesDiv>
);

const RulesDiv = styled.div`
  background-color: #111;
  color: #999;

  h2 {
    font-size: 25px;
  }

  & > ol {
    margin-top: 0;
    margin-bottom: 10px;

    & > li {
      font-size: 16px;
      color: #999;
    }
  }
`;

export default TitanRules;
